<h2 _ngcontent-c6="" class="page-heading">Closures</h2>
<app-response-text
class="uk-text-center"
[lambdaMessage]="lambdaMessage"
[lambdaError]="lambdaError"
></app-response-text>
<div class="InitShutdown">
  <button mat-raised-button color="accent" [routerLink]="[shutdownUrl]">Initiate Emergency Shutdown</button>
</div>
<br>
<div class="selectors">
  <select
  class="custom-select" 
  [(ngModel)]="lobSelected"
  (ngModelChange)="filterQueues()"
  [disabled]="!isTelecom"
>
  <option selected>All LOBs</option>
  <option *ngFor="let lob of lobs" [ngValue]="lob[1]">{{
    lob[0]
  }}</option>
</select>
<div class="divider"></div>
<select
  class="custom-select" 
  [(ngModel)]="groupSelected"
  (ngModelChange)="filterQueues()"
>
  <option selected>All Groups</option>
  <option *ngFor="let group of filteredGroups" [ngValue]="group">{{
    group.groupName
  }}</option>
</select>
<div class="divider"></div>
<select
  class="custom-select" 
  [(ngModel)]="queueSelected"
  (ngModelChange)="filterQueues()"
>
  <option selected>All Queues</option>
  <option *ngFor="let queue of filteredQueues" [ngValue]="queue">{{
    queue.queueName
  }}</option>
</select>
</div>
<br>
<div class="mainTable">
  <app-data-grid [(data)]="currentClosureData" (itemChange)="updateItem($event)" [(isValid)]="formValid"
  [formTemplate]="form" [viewTemplate]="target" [footerTemplate]="footer" [columnNames]="[
            'Select',
            'LOB',
            'Group',
            'Queue',
            'Type',
            'Message',
            'Start Date',
            'Start Time',
            'End Date',
            'End Time']" 
            [spacing]="[0.5, 1, 2, 3, 1, 4, 2, 1, 2, 1, 1]"
            [itemsPerPage]="6"
            [allowAdd]="false"
            [allowDelete]="false"
  [objectBluePrint]="{ messageDuration: '' }">

</app-data-grid>
<ng-template #form let-message>
  <td><input type="checkbox" (click)="selectClosure(message)"></td>
  <td>{{message.message.LOB}}</td>
  <ng-container *ngIf="message.groupId">
    <td>{{idMap.get(message.groupId).groupName}}</td>
  </ng-container>
  <ng-container *ngIf="!message.groupId">
    <td>N/A</td>
  </ng-container>
  <td>{{message.message.queueName}}</td>
  <td>{{message.message.messageType}}</td>
  <td>{{message.message.msgText[message.language]}}</td>
  <td>{{message.messageDuration.messageStartDate}}</td>
  <td>{{message.messageDuration.messageStartTime}}</td>
  <ng-container *ngIf="message.type == 'Group'">
    <td>{{message.messageDuration.messageEndDate}}</td>
    <td>{{message.messageDuration.messageEndTime}}</td>
  </ng-container>
  <ng-container *ngIf="message.type == 'Queue'">
    <td><input
      type="date"
      [(ngModel)]="message.messageDuration.messageEndDate"
      [max]="maxDate"
      [min]="minDate"
      (focusout)="formValid = validate(message)"
    /></td>
    <td>
      <input type="time" [(ngModel)]="message.messageDuration.messageEndTime" (focusout)="formValid = validate(message)" />
    </td>
  </ng-container>
</ng-template>

<ng-template #target let-message>
  <td ><input type="checkbox" (click)="selectClosure(message)"></td>
  <ng-container *ngIf="message.message.LOB">
    <td class="queueInfo">{{message.message.LOB}}</td>
  </ng-container>
  <ng-container *ngIf="!message.message.LOB">
    <td class="queueInfo">N/A</td>
  </ng-container>
  <ng-container *ngIf="idMap.get(message.groupId)">
    <td class="queueInfo">{{idMap.get(message.groupId).groupName}}</td>
  </ng-container>
  <ng-container *ngIf="!idMap.get(message.groupId)">
    <td class="queueInfo">N/A</td>
  </ng-container>
  <ng-container *ngIf="message.message.queueName">
    <td class="queueInfo">{{message.message.queueName}}</td>
  </ng-container>
  <ng-container *ngIf="!message.message.queueName">
    <td class="queueInfo">N/A</td>
  </ng-container>
  <td>{{message.message.messageType}}</td>
  <ng-container *ngIf="message.language">
    <td class="queueInfo">{{message.message.msgText[message.language]}}</td>
  </ng-container>
  <ng-container *ngIf="!message.language">
    <td class="queueInfo">N/A</td>
  </ng-container>

  <ng-container *ngIf="message.messageDuration.messageStartDate">
    <td class="queueInfo">{{message.messageDuration.messageStartDate}}</td>
  </ng-container>
  <ng-container *ngIf="!message.messageDuration.messageStartDate">
    <td class="queueInfo">N/A</td>
  </ng-container>

  <ng-container *ngIf="message.messageDuration.messageStartTime">
    <td class="queueInfo">{{message.messageDuration.messageStartTime}}</td>
  </ng-container>
  <ng-container *ngIf="!message.messageDuration.messageStartTime">
    <td class="queueInfo">N/A</td>
  </ng-container>
  <ng-container *ngIf="message.messageDuration.messageEndDate">
    <td class="queueInfo">{{message.messageDuration.messageEndDate}}</td>
  </ng-container>
  <ng-container *ngIf="!message.messageDuration.messageEndDate">
    <td class="queueInfo">N/A</td>
  </ng-container>
  <ng-container *ngIf="message.messageDuration.messageEndTime">
    <td class="queueInfo">{{message.messageDuration.messageEndTime}}</td>
  </ng-container>
  <ng-container *ngIf="!message.messageDuration.messageEndTime">
    <td class="queueInfo">N/A</td>
  </ng-container>
</ng-template>
<ng-template #footer>
  <div class="banner">
      <span class="banner-item">All times are in EST (UTC -5)</span>
      <span class="banner-item">Time Format: Military Time</span>
  </div>
</ng-template>
</div>
<br>
<div class="endClosures">
  <button mat-raised-button color="primary" (click)="endSelectedClosures()">End Selected Closures</button>
</div>
<br>
<h2 _ngcontent-c6="" class="page-heading">{{closureType}} Closures</h2>
<div class = "endClosures">
  <ng-container *ngIf="(closureType == 'Upcoming' && inactiveClosureData.length == 0)">
    No Upcoming Closures. (Next 7 days)
  </ng-container>
  <ng-container *ngIf="(closureType == 'Historical' && inactiveClosureData.length == 0)">
    No Historical Data available.
  </ng-container>
  <ng-container *ngIf="(closureType == 'Future' && inactiveClosureData.length == 0)">
    No Future Closures Scheduled. (More than 7 days away)
  </ng-container>
</div>
<div class="selectors">
  <select class="custom-select" [(ngModel)]="closureType" (ngModelChange)="sortClosures()">
    <option selected>Upcoming</option>
    <option>Future</option>
    <option>Historical</option>
  </select>
</div>
<br>
<div class="mainTable">
  <app-data-grid [(data)]="inactiveClosureData"
  [headerTemplate]="header"[formTemplate]="form2" [viewTemplate]="target2" [footerTemplate]="footer" 
  [allowEdit]="false"
  [allowAdd]="false"
  [allowDelete]="false"
   [columnNames]="[
            'LOB',
            'Group',
            'Queue',
            'Type',
            'Message',
            'Start Date',
            'Start Time',
            'End Date',
            'End Time' ]"
            [spacing]="[1, 2, 3, 1, 4, 2, 1, 2, 1, 1]"
            [itemsPerPage]="6"
  [objectBluePrint]="{ messageDuration: '' }"></app-data-grid>

  <ng-template #header>
    <div class="top" fxLayout.xs="row" fxLayoutGap="10px" fxLayoutAlign="space-around center">
        <input type="text" class="search" placeholder="search..." [(ngModel)]="searchString" (ngModelChange)="applyFilter()">
    </div>
  </ng-template>

  <ng-template #form2 let-message>
    <td>{{message.message.LOB}}</td>
    <ng-container *ngIf="message.groupId">
      <td>{{idMap.get(message.groupId).groupName}}</td>
    </ng-container>
    <ng-container *ngIf="!message.groupId">
      <td>N/A</td>
    </ng-container>
    <td>{{message.message.queueName}}</td>
    <td>{{message.message.messageType}}</td>
    <td>{{message.message.msgText[message.language]}}</td>
    <td>{{message.messageDuration.messageStartDate}}</td>
    <td>{{message.messageDuration.messageStartTime}}</td>
    <td>{{message.messageDuration.messageEndDate}}</td>
    <td>{{message.messageDuration.messageEndTime}}</td>
  </ng-template>
  
  <ng-template #target2 let-message>
    <ng-container *ngIf="message.message.LOB">
      <td class="queueInfo">{{message.message.LOB}}</td>
    </ng-container>
    <ng-container *ngIf="!message.message.LOB">
      <td class="queueInfo">N/A</td>
    </ng-container>
    <ng-container *ngIf="idMap.get(message.groupId)">
      <td class="queueInfo">{{idMap.get(message.groupId).groupName}}</td>
    </ng-container>
    <ng-container *ngIf="!idMap.get(message.groupId)">
      <td class="queueInfo">N/A</td>
    </ng-container>
    <ng-container *ngIf="message.message.queueName">
      <td class="queueInfo">{{message.message.queueName}}</td>
    </ng-container>
    <ng-container *ngIf="!message.message.queueName">
      <td class="queueInfo">N/A</td>
    </ng-container>
    <td>{{message.message.messageType}}</td>
    <ng-container *ngIf="message.language">
      <td class="queueInfo">{{message.message.msgText[message.language]}}</td>
    </ng-container>
    <ng-container *ngIf="!message.language">
      <td class="queueInfo">N/A</td>
    </ng-container>
  
    <ng-container *ngIf="message.messageDuration.messageStartDate">
      <td class="queueInfo">{{message.messageDuration.messageStartDate}}</td>
    </ng-container>
    <ng-container *ngIf="!message.messageDuration.messageStartDate">
      <td class="queueInfo">N/A</td>
    </ng-container>
  
    <ng-container *ngIf="message.messageDuration.messageStartTime">
      <td class="queueInfo">{{message.messageDuration.messageStartTime}}</td>
    </ng-container>
    <ng-container *ngIf="!message.messageDuration.messageStartTime">
      <td class="queueInfo">N/A</td>
    </ng-container>
    <ng-container *ngIf="message.messageDuration.messageEndDate">
      <td class="queueInfo">{{message.messageDuration.messageEndDate}}</td>
    </ng-container>
    <ng-container *ngIf="!message.messageDuration.messageEndDate">
      <td class="queueInfo">N/A</td>
    </ng-container>
    <ng-container *ngIf="message.messageDuration.messageEndTime">
      <td class="queueInfo">{{message.messageDuration.messageEndTime}}</td>
    </ng-container>
    <ng-container *ngIf="!message.messageDuration.messageEndTime">
      <td class="queueInfo">N/A</td>
    </ng-container>
  </ng-template>
  <ng-template #footer>
    <div class="banner">
        <span class="banner-item">All times are in EST (UTC -5)</span>
        <span class="banner-item">Time Format: Military Time</span>
    </div>
</ng-template>
</div>
<br>
